import Resource from './Resource';

export default class FileToken extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let config = {
			route: 'class-pages/:courseSectionGuid/file-upload-token',
			routeParams: routeParams,
			query: query,
			data: data
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
